import { Icon, Tooltip } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { Component } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { compose } from 'redux'

import { connect } from 'react-redux'

import { inject } from 'modules/di'
import { ComposeProps, DispatchProp } from 'modules/store'

import { links } from '../../app.links'
import { AspireLogo, getRedirectReferrerPath } from '../../shared'

import { Providers } from '../auth.module'

import * as fromAuthStore from '../store'

import './login.scss'

export type Props = OwnProps & Providers & StateProps & DispatchProp
type OwnProps = RouteComponentProps<any>
type StateProps = {
  loggedIn: boolean
  loggingOut: boolean
}

const mapStateToProps = (state: fromAuthStore.AuthState) => ({
  loggedIn: fromAuthStore.getLoggedIn(state),
  loggingOut: fromAuthStore.getIsLoggingOut(state),
})

const mapInjectablesToProps = inject<Providers>(({ authService }) => ({ authService }))
const enhance: ComposeProps<Props, OwnProps> = compose<any>(mapInjectablesToProps, connect(mapStateToProps))

const TOOLTIP_DELAY = 900

export class Login extends Component<Props> {
  render() {
    const { location, authService, loggedIn } = this.props
    const from = getRedirectReferrerPath(location)
    const urls = {
      adfs: authService.buildLoginURI(links.auth.loginAdfs(), from),
    }

    if (loggedIn) {
      return (
        <Redirect
          to={{
            pathname: links.frontFace.home(),
          }}
        />
      )
    }

    return (
      <>
        <div className="login">
          <AspireLogo className="login__logo" size="large" color="color" noClaim />
          <div className="login__panel anim--fade-in">
            <h1 className="login__heading">Hello!</h1>
            <h2 className="login__message">We are happy to see you!</h2>
            <label className="login__label">log in with</label>
            <Tooltip
              className="login__tooltip"
              content="e.g. domain\john.doe or john.doe@company.com"
              hoverOpenDelay={TOOLTIP_DELAY}
              targetTagName="div"
            >
              <a
                className="login__button bp3-button bp3-fill bp3-large bp3-minimal"
                data-test="login-adsf"
                href={urls.adfs}
              >
                <Icon icon={IconNames.GLOBE} />
                Login with ADFS
              </a>
            </Tooltip>
          </div>
        </div>
      </>
    )
  }

  componentDidMount() {
    const { dispatch, loggedIn } = this.props
    !loggedIn && dispatch(new fromAuthStore.actions.CurentUserAction())
  }
}

export default enhance(Login)



// WEBPACK FOOTER //
// ./src/app/auth/components/login.tsx